module.exports = __webpack_public_path__ + "static/btn-fairground.c86ad3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn-fairground.jpg
// module id = 532
// module chunks = 114276838955818